// extracted by mini-css-extract-plugin
export default {"main":"index_main_1lXwW","main_middle":"index_main_middle_9pjTB","main_right":"index_main_right_iZJHU","ad1":"index_ad1_dAWvp"};